import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CountUp from "react-countup";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./Footer";
const Privacy_policy = () => {
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}
        <section
          className="page-title bg-overlay-black-60 parallax"
          data-jarallax='{"speed": 0.6}'
          /*style={{ backgroundImage: "url(/assets/images/bg/02.jpg)" }}*/
          style={{
            backgroundImage:
              "url(/assets/images/Entreprise/entreprise-prensentation.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>Politique de Confidentialité</h1>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> Accueil
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>Politique de Confidentialité</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}

        <section className="privacy-policy page-section-ptb">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong>
                    {" "}
                    AVIS DE CONFIDENTIALITÉ ET MENTIONS LÉGALES DE SACEM
                    INDUSTRIES
                  </strong>
                </h4>
                <p>
                  Chez SACEM Industries, le respect de vos droits fondamentaux
                  en matière de protection des données et de la vie privée
                  constitue une priorité absolue et un engagement éthique
                  incontournable. Dans un environnement numérique en constante
                  évolution, nous sommes pleinement conscients de l'importance
                  stratégique de sécuriser les informations que vous nous
                  confiez, que vous soyez un client, un partenaire commercial,
                  un collaborateur naviguant sur nos portails internes ou un
                  simple visiteur de notre site internet.
                </p>
                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong>
                    {" "}
                    1. Propriété Intellectuelle et Droits d'Auteur
                  </strong>{" "}
                </h4>
                <p>
                  La structure générale du site{" "}
                  <strong>sacemindustries.com</strong> , ainsi que les
                  logiciels, textes, bases de données, images animées ou non,
                  sons, savoir-faire et tous les autres éléments composant le
                  site sont la propriété exclusive de SACEM Industries.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Marques Déposées: </strong> Le nom{" "}
                      <strong> SACEM Industries</strong>, son logo, ainsi que
                      les slogans et éléments graphiques associés sont des
                      marques déposées et protégées.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Interdiction de Reproduction : </strong> Toute
                      représentation, reproduction, modification, publication,
                      adaptation, traduction ou exploitation partielle ou totale
                      des contenus, des marques ou du site, par quelque procédé
                      que ce soit et sur quelque support que ce soit, sans
                      l'autorisation expresse, écrite et préalable de SACEM
                      Industries est strictement interdite. Toute utilisation
                      non autorisée sera considérée comme constitutive d’une
                      contrefaçon et poursuivie conformément aux dispositions
                      légales relatives à la propriété intellectuelle.
                    </p>{" "}
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>2. Conditions Générales d'Utilisation (CGU)</strong>
                </h4>
                <p>
                  L'utilisation du site sacemindustries.com implique
                  l'acceptation pleine et entière des conditions générales
                  d'utilisation ci-présentes. Ce site est normalement accessible
                  à tout moment aux utilisateurs. Une interruption pour raison
                  de maintenance technique ou de mise à jour peut être toutefois
                  décidée par SACEM Industries, qui s'efforcera alors de
                  maintenir la continuité du service dans les meilleurs délais.
                </p>

                <h4 className="mt-30 theme-color">
                  {" "}
                  <strong>
                    {" "}
                    3. Politique de Confidentialité et Protection des Données
                    Personnelles
                  </strong>{" "}
                </h4>
                <p>
                  SACEM Industries s'engage à ce que la collecte et le
                  traitement de vos données, effectués à partir du site
                  sacemindustries.com, soient conformes aux réglementations
                  nationales et internationales en vigueur concernant la
                  protection des données à caractère personnel.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Collecte des données : </strong>Les données
                      personnelles sont collectées de manière loyale et licite
                      (formulaires de contact, authentification sur les portails
                      sécurisés, soumission de documents). Elles incluent
                      généralement le nom, le prénom, l'adresse e-mail
                      professionnelle, et les identifiants de connexion.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Finalité du traitement: </strong> Les informations
                      recueillies sont destinées exclusivement à SACEM
                      Industries pour la gestion des relations commerciales, le
                      fonctionnement des plateformes internes (gestion des rôles
                      et autorisations), et le support technique. En aucun cas
                      ces données ne seront cédées, vendues ou louées à des
                      tiers.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Sécurité des données : </strong> SACEM Industries
                      met en œuvre des mesures de sécurité techniques et
                      organisationnelles rigoureuses pour protéger vos données
                      contre toute destruction, perte, altération, divulgation
                      ou accès non autorisé.
                    </p>{" "}
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Exercice de vos droits : </strong>Vous disposez
                      d'un droit d'accès, de rectification, de limitation,
                      d'opposition et de suppression des données personnelles
                      vous concernant. Pour exercer ces droits, vous pouvez
                      adresser votre demande par e-mail à :{" "}
                      <strong>contact@sacemindustries.com </strong>
                      ou par courrier postal au siège social.
                    </p>{" "}
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>4. Politique de Gestion des Cookies</strong>
                </h4>
                <p>
                  La navigation sur le site sacemindustries.com est susceptible
                  de provoquer l’installation de cookie(s) sur le terminal de
                  l’utilisateur.
                </p>
                <ul className="list list-unstyled">
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Nature des cookies : </strong>Un cookie est un
                      fichier de petite taille qui enregistre des informations
                      relatives à la navigation d’un ordinateur sur un site
                      (gestion des sessions utilisateur, statistiques de tableau
                      de bord, mémorisation des préférences).
                    </p>
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Finalité : </strong> Les cookies utilisés par
                      SACEM Industries ont pour but exclusif de faciliter la
                      navigation, de sécuriser les connexions aux espaces privés
                      et de mesurer l'audience du site pour en améliorer les
                      performances.
                    </p>
                  </li>
                  <li>
                    {" "}
                    <i className="fa fa-angle-right"></i>{" "}
                    <p>
                      <strong>Consentement et paramétrage : </strong> Lors de
                      votre première visite, un bandeau vous informe de
                      l'utilisation de cookies. Vous avez la possibilité de
                      paramétrer votre navigateur pour refuser l'installation de
                      certains cookies non essentiels au fonctionnement du site.
                    </p>
                  </li>
                </ul>
                <h4 className="mt-30 theme-color">
                  <strong>5. Droit Applicable et Juridiction Compétente</strong>
                </h4>
                <p>
                  Tout litige en relation avec l’utilisation du site
                  sacemindustries.com est soumis au droit applicable en vigueur.
                  En dehors des cas où la loi ne le permet pas, il est fait
                  attribution exclusive de juridiction aux tribunaux compétents
                  du siège social de SACEM Industries.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Privacy_policy;
